import React from 'react';

import { createCache as createCacheExchange, createClient } from '../client';
import { logger } from '../logger';
import type { OfflineStorage } from '../storage';
import { offlineStorage } from '../storage';

// ────────────────────────────────────────────────────────────────────────────────

type ClientState = Awaited<ReturnType<typeof makeClient>> | null;

export const useUrqlClient = () => {
  const [client, setClient] = React.useState<ClientState>(null);

  React.useEffect(() => {
    (async () => {
      setClient(await makeClient(offlineStorage));
    })();
  }, []);

  return client;
};

// ──── Utils ──────────────────────────────────────────────────────────────────

const makeClient = async (storage: OfflineStorage) => {
  const cacheExchange = createCacheExchange(storage);

  logger.debug('Created urql client');

  return createClient(cacheExchange);
};
